import { DOCUMENT } from '@angular/common';
import { ElementRef, Inject, Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  private loadedScripts: Set<string> = new Set();

  constructor( @Inject(DOCUMENT) private document: Document){}

  loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    renderer.appendChild(this.document.body, script);
    return script;
  }

  // loadScripts(scriptUrls: string[]): Promise<void[]> {
  //   return Promise.all(scriptUrls.map((url) => this.loadScript(url)));
  // }
}
